import { render, staticRenderFns } from "./bAlert.vue?vue&type=template&id=eabc7b10&"
import script from "./bAlert.vue?vue&type=script&lang=js&"
export * from "./bAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports